import { render } from "./EonIconButton.vue?vue&type=template&id=35d1d57a"
import script from "./EonIconButton.vue?vue&type=script&lang=js"
export * from "./EonIconButton.vue?vue&type=script&lang=js"

import "./EonIconButton.vue?vue&type=style&index=0&id=35d1d57a&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__